import { render, staticRenderFns } from "./WabidentDropdown.vue?vue&type=template&id=4097983f"
import script from "./WabidentDropdown.vue?vue&type=script&lang=js"
export * from "./WabidentDropdown.vue?vue&type=script&lang=js"
import style0 from "./WabidentDropdown.vue?vue&type=style&index=0&id=4097983f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports